module.exports = __webpack_public_path__ + "img/jessheim.f5fc6ce1.jpeg";